import React from 'react'

const Container = ({children, className, color}) => {
  return (
    <section style={{background: color ? color : 'transparent'}}>
      <div className={`container mx-auto ${className}`}>
        {children}
      </div>
    </section>
  )
}

export { Container }
